/*
 * Fixed position header
 * ----------------------------------------------- */
jQuery(window).on("load scroll", function () {
  var $jsHeader = $(".js-header");

  $jsHeader.each(function () {
    var scroll = $(window).scrollTop();

    if (!$jsHeader.hasClass("allway-navbar")) {
      if (scroll > 300) {
        $jsHeader.addClass("is-scrolled");
      } else {
        $jsHeader.removeClass("is-scrolled");
      }
    }
  });
});
